import React from 'react';
import { Pagination } from '@guildeducationinc/recess';
import styles from './ResultsPagination.module.scss';

interface Props {
	totalCount: number;
	totalPages: number;
	setPageNumber: (page: number) => void;
	page: number;
}
export const ResultsPagination: React.FC<Props> = ({
	totalCount,
	totalPages,
	setPageNumber,
	page,
}) => {
	return totalCount > 10 ? (
		<div className={styles.paginationContainer}>
			<Pagination
				currentPage={page}
				onChangePage={setPageNumber}
				testid='program-results-pagination'
				totalPages={totalPages}
			/>
		</div>
	) : null;
};
